import 'lazysizes/plugins/respimg/ls.respimg'
import 'lazysizes/plugins/bgset/ls.bgset.min.js'
import 'lazysizes'
import './modules/keyboard-focus'
import './modules/nav-keyboard'
import './modules/mobile-nav'
import './modules/image-with-text-tabs'
import './modules/body-scroll'
import './modules/alert-bar'
import './modules/quote-slider'
import './modules/logo-slider'
import './modules/table-fix'
import './modules/marketo'
import './modules/video-modal'
import './modules/richTextAccordions'

global.$ = global.jQuery = require('jquery')
import 'bootstrap'

function offsetAnchor () {
    if (location.hash.length !== 0) {
        window.scrollTo(window.scrollX, window.scrollY - 100)
    }
}
window.addEventListener('hashchange', offsetAnchor)
window.setTimeout(offsetAnchor, 75)
